var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "card-body" }, [_c('div', { staticClass: "card-body-item" }, [_c('h5', [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _vm.desc ? _c('auto-tips', { style: { 'margin-left': '5px' }, attrs: { "content": _vm.desc, "max-length": 0, "tooltipProps": { effect: 'dark' } } }) : _vm._e()], 1), _vm._v(" "), _c('el-switch', { attrs: { "active-text": "ON", "inactive-text": "OFF", "active-value": 1, "inactive-value": 2 }, model: { value: _vm.model, callback: function callback($$v) {
        _vm.model = $$v;
      }, expression: "model" } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };